var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showState ? _c('div', {
    staticClass: "g_tips"
  }, [_c('span', {
    staticClass: "txt",
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  })]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };